import React, { useEffect, useState } from 'react';
import { DataTable, DataTableStateEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FormSectionElements, Pagination } from "../../entities/formTemplateDataType";
import { PageSizes } from 'pdf-lib';
import axios from 'axios';
import { AIP_PATH, IRP_STATUS_MAPPING } from '../../entities/Constants';
import { getApiUrl } from '../../utilities/URLUtils';
import { getRootComponent } from '../../utilities/ElementUtils';

export type IRPStatusTableProps = {
    field: FormSectionElements;
    pageSizeOption?: number[];
    lang: 'en' | 'fr';
}

const IRPStatusTable = ({field, lang, pageSizeOption}: IRPStatusTableProps) => {
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState(20)
    const [total, setTotal] = useState(field.TableData?.paginator?.total)
    const [tableData, setTableData] = useState(field.Value)
    const [payload, setPayload] = useState(field.TableData?.triggerPayload);
    const [paginator, setPaginator] = useState(field.TableData?.paginator);
    const [lazyState, setLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: field.TableData?.paginator?.sort?.[0]?.sortBy?.toLowerCase(),
        sortOrder: !field.TableData?.paginator?.sort?.[0]?.sortOrder ? 0 : field.TableData?.paginator?.sort?.[0]?.sortOrder === 'asc' ? -1 : 1,
        filters: {}
    });

    const appId = getRootComponent(field).CategoryId;

    useEffect(() => {
        if (payload["Account__number"]) {
            search()
        }
    }, [lazyState]);

    useEffect(() => {
        const sortorder = !field.TableData?.paginator?.sort?.[0]?.sortOrder ? 0 : field.TableData?.paginator?.sort?.[0]?.sortOrder === 'asc' ? -1 : 1;
        if (field.TableData?.paginator?.sort?.[0].sortBy?.toLowerCase() === 'status' && (sortorder === 1 || sortorder === -1)) {
            setTableData(resortByStatus(field.Value as any[], sortorder));
        } else {
            setTableData(field.Value);
        }
        
        setTotal(field.TableData?.paginator?.total);
        setLazyState({
            first: 0,
            page: 1,
            rows: rows,
            sortField: field.TableData?.paginator?.sort?.[0].sortBy?.toLowerCase(),
            sortOrder: !field.TableData?.paginator?.sort?.[0]?.sortOrder ? 0 : field.TableData?.paginator?.sort?.[0]?.sortOrder === 'asc' ? -1 : 1,
            filters:{},
        });
        setPaginator(field.TableData?.paginator);
        setPayload(field.TableData?.triggerPayload);
    }, [field.Value]);

    const resortByStatus = (dataSet: any[], order: -1 | 1) => {
        if (dataSet?.length) {
            return dataSet.sort((a, b) =>{
                if (a.status > b.status) return order === 1 ? -1 : 1;
                if (b.status > a.status) return order === 1 ? 1 : -1;
                return 0;
            });
        }
        return dataSet;
    }

    const displayMessage = (message: String, type: 'error' | 'warning' | 'info') => {

    }

    const search = async () => {
        const data = {...payload ?? {}, pagination: paginator};
        const url = getApiUrl(AIP_PATH[appId]?.search);
        setLoading(true);

        try {
            const response = await axios.post(url, data);
            if (response) {
                let result = response.data;
                if (result.status !== 200) {
                    displayMessage(result?.message, 'error');
                }
                setTotal(result?.pagination?.total);
                if (lazyState.sortField === 'status' && (lazyState.sortOrder === 1 || lazyState.sortOrder === -1) && result?.data?.length) {
                    setTableData(resortByStatus(result.data, lazyState.sortOrder))
                } else {
                    setTableData(result?.data);
                }
            }
        } catch {
            console.log("search failed");
            displayMessage("There was a problem", "error");
        } finally {
            setLoading(false);
        }

    }

    const handlePageChang = (event: DataTableStateEvent) => {
        const sort = getSort(event.sortField, event.sortOrder) as {sortBy: string, sortOrder: "asc" | "desc"};
        const paging: Pagination = {
            page: event.page + 1,
            pageSize: event.rows,
            total: paginator?.total ?? 0,
            sort: sort ? [sort] : undefined,
        }
        setPaginator(paging);
        setRows(event.rows);
        setupLazyStateByEvent(event)

    }

    const getSort = (sortBy?: string, order?: 0 | 1 | -1): { sortBy: string; sortOrder: 'asc' | 'desc'; } | null => {
        if (sortBy && (order === -1 || order === 1)) {
            return { sortBy, sortOrder: order === 1 ? "desc" :  "asc" }
        }
        return null;
    }

    const setupLazyStateByEvent = (event: DataTableStateEvent) => {
        const lazy = {
            page: event.page,
            first: event.first,
            rows: event.rows,
            sortField: event.sortField,
            sortOrder: event.sortOrder,
            filters: {},
        }
        setLazyState(lazy)
    }

    const handleDataSort = (event: DataTableStateEvent) => {
        console.log("handle sort: ", event);
        const sort = getSort(event.sortField, event.sortOrder)
        const paging = { ...paginator, sort: sort ? [sort] : undefined }
        setPaginator(paging);
        setupLazyStateByEvent(event)
    }

    const statusTemplate = (rowData) => {
        const statusKey = Object.keys(IRP_STATUS_MAPPING).find(key => key === rowData.status);
        return lang === 'en' ? statusKey : IRP_STATUS_MAPPING[statusKey];
    }

    return (
            <DataTable value={tableData}
                showGridlines
                lazy
                filterDisplay="row"
                loading={loading}
                rows={rows}
                paginator={!!paginator}
                first={lazyState.first}
                // rowsPerPageOptions={}
                totalRecords={total}
                sortField={lazyState.sortField}
                sortOrder={(lazyState.sortOrder ?? 0) as 0 | 1 | -1}
                onPage={handlePageChang}
                onSort={handleDataSort}
                header={lang === 'en' ? field.ENUTitle : field.FRATitle}
                id={`data-table-${field.Id}`}
                emptyMessage={lang === 'en' ? "No customers found." : "Aucun client trouvé."}
            >
                {/* <Column header={lang === 'en' ? 'Account Number' : 'Numéro de compte'} field="accountNumber"></Column> */}
                <Column sortable header={lang === 'en' ? "Request Type" : 'Numéro de compte'} field="supplementType" />
                <Column sortable header={lang === 'en' ? "Status" : 'État'} field="status" body={statusTemplate}/>
                <Column sortable header={lang === 'en' ? "Unit number" : 'Numéro d’unité'} field="unitNumber" />
            </DataTable>
    );
}

export default IRPStatusTable;